export default "__VITE_ASSET__86225d53__"